/**
 * User mixin
 *
 * @author jaehyub.lee@emcast.com
 */

import { mapState } from "vuex";
import { commonMixin } from "./common";
import loginApi from "@/api/loginApi";
import popupApi from "@/api/popupApi";
import memberApi from "@/api/memberApi";

export const userMixin = {
  mixins: [commonMixin],

  data() {
    return {
      dormancyStatus: false,
      userParams: JSON.parse(localStorage.getItem("userParams")),
    };
  },

  computed: {
    ...mapState({
      dormancyUserData: (state) => state.dormancy.userData,
    }),
  },

  methods: {
    getUserBackgroundColor() {
      return localStorage.getItem("bgColors");
    },

    getUserFirstChar() {
      return localStorage.getItem("firstChar");
    },

    // 유저 상태 확인 (auditor.register까지 param으로 받아야 함)
    checkDeactivateUser(userData) {
      if (userData && !userData.status) return false;
      const deActivatedList = ["WITHDRAWAL", "DORMANCY"];
      const isDeactivatedUser = deActivatedList.includes(userData.status.value);
      return isDeactivatedUser;
    },

    // 유저 이름 처리 부분
    handleUserName(userData) {
      const nameObj = {
        first: userData.name
          ? userData.name.first
          : userData.first
            ? userData.first
            : "",
        last: userData.name
          ? userData.name.last
          : userData.last
            ? userData.last
            : "",
        fullName: userData.name
          ? userData.name.fullName
          : userData.fullName
            ? userData.fullName
            : "",
      };

      return this.$t("3437", {
        first: nameObj.first,
        last: nameObj.last,
      });
    },

    handleMaskingEmail(email) {
      const id = email.split("@")[0];
      if (id.length > 2) {
        const domain = email.split("@")[1];
        return email.substring(0, 3) + "*".repeat(id.length - 3) + "@" + domain;
      } else {
        return email;
      }
    },

    // 사용자 차단
    async blockUser(item, isBlocked, type) {
      // target 재정의 (각 컴포넌트에서 받아오는 item의 key값이 다름)
      let target = {};
      target = item.auditor
        ? item.auditor.register
        : item.writer
          ? item.writer
          : {};
      if (type === "REVIEW") {
        target.id = item.reviewer.memberId ? item.reviewer.memberId : item.reviewer.id;
        target.name = item.reviewer.name;
      }
      let targetId = target.id;

      const dialogResult = await this.$confirm({
        title: isBlocked
          ? this.$t("3816")
          : this.$t("3809", {
            str: this.$t("3437", {
              last: target.name.last,
              first: target.name.first,
            }),
          }),
        content: isBlocked
          ? this.$t("3817")
          : this.$t("3810", {
            str: this.$t("3437", {
              last: target.name.last,
              first: target.name.first,
            }),
          }),
        accept: isBlocked ? this.$t("3818") : this.$t("3811"),
        cancel: isBlocked ? this.$t("3819") : this.$t("3812"),
      });

      // 다이얼로그 및 API 요청
      try {
        if (dialogResult) {
          const blockResult = isBlocked
            ? await memberApi.restoreBlock(targetId)
            : await memberApi.requestUserBlock(targetId);
          if (blockResult && blockResult.data) {
            this.$snackOpen({
              contents: isBlocked
                ? this.$t("3820", {
                  str: this.$t("3437", {
                    last: target.name.last,
                    first: target.name.first,
                  }),
                })
                : this.$t("3813"),
            });
          }
        }
      } catch (error) {
        console.log("BLOCK USER ERROR : ", error);
        return error;
      }
    },

    async checkUser() {
      // 1. 휴면 회원인지 확인
      if (this.dormancyUserData.dormancy === true) {
        this.$router.push({
          name: "Dormancy",
        });

        // 2. 약관동의를 받았는지 확인
      } else if (this.dormancyUserData.termsAgree === false) {
        try {
          this.$router.push({
            name: "termsagree",
            query: { ...this.$route.query, type: "DORMANCY" },
          });
        } catch (error) {
          console.log("TERMS ERROR : ", error);
        }

        // 3. 이메일 인증을 받았는지 확인
      } else if (this.dormancyUserData.emailAuth === false) {
        this.$confirm({
          title: this.$t("804"),
          content: this.$t("805") + " " + this.$t("806"),
          accept: this.$t("835"),
          cancel: this.$t("834"),
        })
          .then(() => {
            loginApi
              .login(this.setParams())
              .then((res) => {
                console.log("EMAIL_AUTH_LOGIN : ", res);
                this.$router.push({
                  name: "EmailConfirm",
                });
              })
              .catch(() => console.log("EMAIL_AUTH_LOGIN_ERROR"));
          })
          .catch(() => {
            console.log("여기는 이메일 컨펌 다이얼로그 취소 버튼");
            this.$router.push("/login");
          });

        // 4. 비밀번호 변경 주기(6개월) 확인
      } else if (this.dormancyUserData.changePasswordRequest === true) {
        this.$router.push({ name: "MemberChangePassword" });

        // 5. 관리자가 비밀번호를 변경했는지 확인
      } else if (this.dormancyUserData.reIssueChangePassword === true) {
        this.$router.push({ name: "MemberReIssueChangePassword" });

        // 6. 직책코드가 변했는지 확인
      } else if (this.dormancyUserData.responsibilityAuth === false) {
        this.$alert({
          title: this.$t("830"),
          content: this.$t("831") + " " + this.$t("832"),
          accept: this.$t("833"),
        })
          .then(() => {
            this.$router.push("/verificationcode");
          })
          .catch(() => {
            this.$router.push("/login");
          });

        // 7. 매장 양도양수 이후 첫 로그인인지 확인
      } else if (this.dormancyUserData.storeTransfer !== null) {
        this.$router.push({ name: "StoreTransfer" });
      } else {
        popupApi
          .fetpopupDetail()
          .then((response) => {
            this.popupData = response.data.data;
            if (this.popupData.length > 0) {
              this.redirectPath = this.$route.query.redirectPath || "/home?showPopup=1";
              this.callPushNotification();
              this.$router.push(this.redirectPath);
            } else {
              this.redirectPath = this.$route.query.redirectPath || "/home";
              this.callPushNotification();
              this.$router.push(this.redirectPath);
            }
          })
          .catch((error) => {
            console.log("err", error);
          });
      }
    },
  },
};
